import { apiClient } from '@/api/client';
import logger from '@/shared/utils/logger';

export interface TrackingLog {
    utm_source: string;
    utm_medium: string;
    landing_timestamp: string;
}

class TrackingLogService {
    async saveUtmParams() {
        const urlParams = new URLSearchParams(window.location.search);
        const utmSource = urlParams.get('utm_source');
        const utmMedium = urlParams.get('utm_medium');

        const trackingLog: TrackingLog = {
            utm_source: utmSource || '',
            utm_medium: utmMedium || '',
            landing_timestamp: new Date().toISOString(),
        };

        if (utmSource || utmMedium) {
            try {
                await trackingLogService.createTrackingLog([trackingLog]);
            } catch (error) {
                logger.error('UTM 파라미터 저장 실패:', error);
            }
        }
    }

    async createTrackingLog(trackingLog: TrackingLog[]) {
        const response = await apiClient.post('/logs:utm', trackingLog);
        return response.data;
    }
}

export const trackingLogService = new TrackingLogService();
